import React from 'react';
import Select, { MultiValue, SingleValue } from 'react-select';
import CustomOption from './chechboxindex';
import './SearchableDropDownComponent.css';
import InfoBar from '../InfoBars';
import CustomTooltip from '../CustomTooltip';
import Cross from '@assets/svg/cross.svg';
import { components } from 'react-select';


interface OptionType {
  value: string;
  label: string;
  code?: string;
  disabled?: boolean;
}
interface DropDownProps {
  dropDownType?: 'error' | 'success' | 'entered' | 'general';
  options: OptionType[];
  disableOptions?: OptionType[];
  placeHolder?: string;
  onChange: (value: string | string[] | OptionType | null) => any;
  onInputChange?: (value: string) => any;
  multipleSelection: boolean;
  dropDownDisable: boolean;
  afterFocus?: string;
  dropLabelName?: string;
  ifRequired?: boolean;
  className?: string;
  dropdownsearchable: boolean;
  defaultValue?: string | any;
  value?: any;
  style?: any;
  isClearable?: boolean
  errorMessage?: string;
  menuPlacement?: "bottom" | "top";
  showSelectedOption?: boolean;
  tooltipNeeded?: boolean;
  toolTipText?: string;
  isAllOptionRequired?: boolean;
}
const SearchableDropdownComponent: React.FC<DropDownProps> = ({
  dropDownType,
  options,
  disableOptions,
  placeHolder,
  onChange,
  onInputChange,
  multipleSelection,
  dropDownDisable,
  afterFocus,
  dropLabelName,
  ifRequired,
  className,
  dropdownsearchable,
  value,
  style,
  isClearable = true,
  defaultValue,
  errorMessage,
  menuPlacement,
  showSelectedOption,
  tooltipNeeded,
  toolTipText,
  isAllOptionRequired = false,
}) => {

  const handleSearch = (e: any) => {
    if (onInputChange) {
      onInputChange(e);
    }
  }

  const handleRemove = (removeValue: any) => {
    const updatedValue = value.filter((item: any) => item.value !== removeValue)
    onChange(
      (updatedValue as MultiValue<OptionType>).map(
        (option) => option.value,
      )
    )
  }

  const handleDropdownChange = (
    selectedOptions: MultiValue<OptionType> | SingleValue<OptionType>,
  ) => {
    // Only for multi-select
    if (isAllOptionRequired && multipleSelection && Array.isArray(value)) {
      const prevValues = value.map((item: OptionType) => item.value);
      const newValues = (selectedOptions as MultiValue<OptionType>).map((item) => item.value);

      const removed = prevValues.filter(val => !newValues.includes(val));
      if (removed.length > 0) {
        if (removed.includes('All')) {
          onChange([]);
          return;
        } else {
          const selected = (selectedOptions as MultiValue<OptionType>) || [];
          onChange(selected.filter(opt => opt?.value !== 'All').map(opt => opt.value));
          return;
        }
      }
    }

    multipleSelection
      ? onChange(
        (selectedOptions as MultiValue<OptionType>).map(
          (option) => option.value,
        )
      )
      : onChange(selectedOptions as SingleValue<OptionType>);

  };
  const CustomOptionWithDisabled = (props: any) => {
    const { data, isDisabled, selectProps } = props;

    // Check if this option should be disabled
    const shouldDisable = data.disabled ||
      (selectProps.disableOptions && selectProps.disableOptions.some((opt: OptionType) => opt.value === data.value)) ||
      isDisabled;

    return (
      <components.Option
        {...props}
        className={`${props.className} ${shouldDisable ? 'disabled-option' : ''}`}
      >
        <div style={{
          opacity: shouldDisable ? 0.5 : 1,
          cursor: shouldDisable ? 'not-allowed' : 'pointer',
          width: '100%',
          padding: '0', // Remove any padding that might interfere
          margin: '0',
          display: 'block', // Ensure it's always visible
          visibility: 'visible' // Force visibility
        }}>
          {data.label}
        </div>
      </components.Option>
    );
  };
  const CustomMultiValue = (props: any) => {
    if (props.data.value == 'All') return null;
    return <components.MultiValue {...props} />;
  };

  {
    if (dropDownType === 'error') {
      afterFocus = 'red';
    } else if (dropDownType === 'success') {
      afterFocus = 'green';
    } else if (dropDownType === 'entered') {
      afterFocus = 'blue';
    } else {
      afterFocus = '';
    }
  }
  return (
    <div className='multi_select_drop_down_parent_class'>
      <div className={` multi-select-group-${dropDownType} ${className}`}>
        {dropLabelName && (
          <label
            className={`drop-name-required-for-ip ${ifRequired && 'yes'} ${dropDownDisable}`}
          >
            {dropLabelName}
          </label>
        )}
        {tooltipNeeded &&
          <span className='tooltip-info'><CustomTooltip text={toolTipText} /></span>
        }
        <Select
          className={`multi-select-dropdown ${dropDownDisable} `}
          classNamePrefix="multi-select"
          isMulti={multipleSelection}
          options={options}
          placeholder={placeHolder}
          components={{
            ...(multipleSelection ? { Option: CustomOption } : { Option: CustomOptionWithDisabled }),
            MultiValue: CustomMultiValue,
          }}
          isOptionDisabled={(option: OptionType) =>
            !!option?.disabled ||
            (disableOptions ? disableOptions.some(opt => opt.value === option.value) : false)
          }
          // components={multipleSelection ? { Option: CustomOption } : undefined}
          closeMenuOnSelect={!multipleSelection}
          hideSelectedOptions={false}
          onChange={handleDropdownChange}
          onInputChange={handleSearch}
          isDisabled={dropDownDisable}
          isSearchable={dropdownsearchable}
          defaultValue={defaultValue}
          value={value}
          isClearable={!showSelectedOption ? isClearable : false}
          menuPlacement={menuPlacement}
          styles={{
            option: (provided, state) => ({
              ...provided,
              opacity: state.isDisabled ? 0.5 : 1,
              cursor: state.isDisabled ? 'not-allowed' : 'pointer',
              ':hover': {
                ...provided[':hover'],
                backgroundColor: state.isDisabled ? 'transparent' : provided[':hover']?.backgroundColor,
              }
            }),
            multiValue: (provided) => ({
              ...provided,
              display: showSelectedOption ? 'none' : 'flex',
              alignItems: 'center',
              width: 'calc(50% - 10px)',
              margin: '2px',
            }),
            multiValueLabel: (provided) => ({
              ...provided,
              display: showSelectedOption ? 'none' : 'inline'
            }),
            multiValueRemove: (provided) => ({
              ...provided,
              display: 'inline',
              marginLeft: 'auto',
            }),
            valueContainer: (provided) => ({
              ...provided,
              display: 'flex',
              flexWrap: 'wrap',
              overflow: 'overlay'
            }),
            placeholder: (baseStyles) => ({
              ...baseStyles,
              marginLeft: 10,
              color: 'rgba(179, 179, 179, 1)',
              fontWeight: 400,
              fontSize: 12,
            }),
            // valueContainer: (baseStyles) => ({
            //   ...baseStyles,
            //   // display: 'flex',
            //   // alignItems:'center',
            //   flexWrap: 'nowrap',
            //   overflow: 'overlay',
            //   marginLeft: 7,
            // }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderColor: state.isFocused ? afterFocus : 'grey',
              '&:hover': {
                borderColor: state.isFocused ? afterFocus : 'grey',
              },
              flexWrap: state.isFocused ? 'nowrap' : 'nowrap',
              boxShadow: state.isFocused ? 'none' : 'none',
            }),
            ...style
          }}
        />
        <div className="searchable_drop_down_infoBars">
          {dropDownType === 'success' ? (
            <InfoBar
              variant="success"
              message={errorMessage ? errorMessage : ''}
              className="searchable_drop_down_class"
            />
          ) : (
            ''
          )}
          {dropDownType === 'error' ? (
            <InfoBar
              variant="danger"
              message={errorMessage ? errorMessage : ''}
              className="searchable_drop_down_class"
            />
          ) : (
            ''
          )}
        </div>
      </div>

      {showSelectedOption && value && value.length > 0 && (
        <div className='drop-name-selected-list'>
          {value.map((item: any) => (
            <div key={item.value} className='selected-list-area'>
              <span className='multi-select__multi-value__label_List'>{item.label}</span>
              <button
                disabled={dropDownDisable}
                style={{
                  position: 'absolute',
                  right: '10px',
                  background: 'none',
                  border: 'none',
                  cursor: dropDownDisable ? 'auto' : 'pointer',
                }}

                onClick={(event) => {
                  event.preventDefault();
                  handleRemove(item.value);
                }}>{<Cross className="crossIcon" />}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdownComponent;
